import { useOutletContext } from "react-router-dom";
import { Target, Eye, Check } from "lucide-react";
import { Container, Reveal, Eyebrow, PageBanner, siteImg } from "@/site/ui";

export default function About() {
  const c = useOutletContext();
  const a = c.about;
  return (
    <div data-testid="about-page">
      <PageBanner image={c.banners?.about} eyebrow="About Us" title={a.heading} subtitle={a.body} />

      <section className="pt-16 md:pt-20 pb-16 md:pb-24">
        <Container>
          <Reveal><img src={siteImg(a.image)} alt="Raphadon team" className="w-full h-[340px] md:h-[520px] object-cover rounded-[28px] shadow-lg" /></Reveal>
        </Container>
      </section>

      <section className="pb-16 md:pb-24">
        <Container className="grid md:grid-cols-2 gap-6">
          {[{ icon: Target, title: "Our Mission", body: a.mission }, { icon: Eye, title: "Our Vision", body: a.vision }].map((x, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="h-full rounded-3xl border border-gray-100 bg-white p-9 shadow-sm">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[rgb(var(--rgh-primary-rgb)/0.08)] text-[var(--rgh-primary)]"><x.icon size={22} /></span>
                <h3 className="mt-5 text-2xl font-bold tracking-tight">{x.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-[#525252]">{x.body}</p>
              </div>
            </Reveal>
          ))}
        </Container>
      </section>

      <section className="pb-20 md:pb-28 bg-[#FAFAFA] py-16">
        <Container>
          <Reveal><h2 className="text-2xl sm:text-3xl font-bold tracking-tight">Why choose Raphadon</h2></Reveal>
          <div className="mt-8 grid sm:grid-cols-2 gap-x-10 gap-y-4">
            {["World-class clinicians and master technicians", "Advanced bionic & CAD/CAM fabrication", "Compassionate, patient-centred care", "Nationwide reach across 37 states", "End-to-end medical tourism support", "Long-term follow-up and rehabilitation"].map((p, i) => (
              <Reveal key={i} delay={(i % 2) * 0.06}>
                <div className="flex items-start gap-3 py-2">
                  <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--rgh-primary)] text-white"><Check size={14} /></span>
                  <span className="text-base text-[#0A0A0A]">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
